import React from 'react';

const promotion = props => {
	return(
		<>
			<h2>Акции</h2>
		</>
	);
}

export default promotion;